import { Vertical } from "./types/verticalTypes";

export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || "";
export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};
export const PULSE_URL = process.env.REACT_APP_PULSE_URL || "https://pulse.searchpantheon.com";

export const YT_CREATOR_DISCOVERY_API = process.env.REACT_APP_YT_CREATOR_DISCOVERY_API || "https://f82w6xlg38.execute-api.us-east-1.amazonaws.com/";
export const YT_CREATOR_DISCOVERY_API_KEY = process.env.REACT_APP_YT_CREATOR_DISCOVERY_API_KEY || "";

export const IP_LIST = [
  { label: "Pantheon", value: "Pantheon" },
  { label: "NBCU", value: "nbcu" },
  { label: "DreamWorks", value: "DreamWorks" },
  { label: "Universal", value: "Universal" },
];

export const TAGS_LIST = [
  { label: "Wikipedia", value: "wikipedia" },
  { label: "Google Trends", value: "trends" },
  { label: "YouTube", value: "youtube" },
  { label: "YouTube Channel", value: "youtubeChannel" },
  { label: "AO3", value: "a03" },
  /* { label: "Instagram", value: "instagram" }, */
  { label: "Wattpad", value: "wattpad" },
  { label: "Reddit", value: "subreddit" },
  { label: "Parent Company", value: "parentCompany" },
  { label: "Twitter", value: "twitter" },
  { label: "TikTok", value: "tiktok" },
  { label: "Fandom", value: "fandom" },
  { label: "TMS ID", value: "tmsId" },
  { label: "EMS ID", value: "emsId" },
  { label: "Rotten Tomatoes", value: "rtUrl" },
  { label: "Twitch", value: "twitch" },
  { label: "Discord", value: "discord" },
  { label: "Steam", value: "steam" },
  { label: "Wikidata ID", value: "wikidata_id" },
  { label: "IMDb ID", value: "imdb_id" },
  { label: "Custom Tags", value: "cTags" },
  { label: "Item Image", value: "image_url" },
];

export const COMMON_BOX_OFFICE_REGIONS = {
  XDOM: "Domestic",
  // TODO: "XWW" is not returning values for any ocassion, check if is still useful
  XWW: "Worldwide", 
  XNDOM: "International",
  ES: "Spain",
  GB: "United Kingdom",
  AU: "Australia",
  DE: "Germany",
  IT: "Italy",
  FR: "France",
  MX: "Mexico",
  KR: "South Korea",
  BR: "Brazil",
  JP: "Japan",
  TH: "Thailand",
  IN: "India",
  CA: "Canada",
};

export const regionGroups = {
  Regions: ["XDOM", "XWW", "XNDOM"],
  Countries: [
    "ES",
    "GB",
    "AU",
    "DE",
    "IT",
    "FR",
    "MX",
    "KR",
    "BR",
    "JP",
    "TH",
    "IN",
    "CA",
  ],
};

export const formattedBoxOfficeRegions = Object.entries(regionGroups).map(
  ([groupLabel, regionKeys]) => {
    const options = regionKeys.map((key) => ({
      label: COMMON_BOX_OFFICE_REGIONS[key],
      value: key,
      tags: key === "XDOM" ? ["US & Canada"] : [],
    }));
    return { label: groupLabel, options };
  },
);

export const occassion = [
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Weekend", value: "weekend" },
];

export const DEFAULT_FILTERING_QUERY = { tokens: [], operation: "and" };

export const TYPES = {
  PERSONAL: "personal",
};

export const SERVICES = {
  PLATFORMS: "platforms",
  FAVORITES: "favorites",
  RANKING: "ranking",
  EXPLORE: "explore",
  DASHBOARDS: "dashboards",
  TOOLS: "tools",
  CONTROL_PANEL: "controlpanel",
};

export const PLATFORMS = {
  WIKIPEDIA: {
    name: "Wikipedia",
    key: "wikipedia",
  },
  TWITTER: {
    name: "Twitter",
    key: "twitter",
  },
  GOOGLE_TRENDS: {
    name: "Google Trends",
    key: "googletrends",
  },
  REDDIT: {
    name: "Reddit",
    key: "reddit",
  },
  AO3: {
    name: "AO3",
    key: "ao3",
  },
  FANDOM: {
    name: "Fandom",
    key: "fandom",
  },
  WATTPAD: {
    name: "Wattpad",
    key: "wattpad",
  },
  YOUTUBE: {
    name: "YouTube",
    key: "youtube",
  },
  MYANIMELIST: {
    name: "MyAnimeList",
    key: "myanimelist",
  },
  ANILIST: {
    name: "AniList",
    key: "anilist",
  },
  STEAM: {
    name: "Steam",
    key: "steam",
  },
  TWITCH: {
    name: "Twitch",
    key: "twitch",
  },
  PIRACY: {
    name: "Piracy",
    key: "piracy",
  },
  ROTTEN_TOMATOES: {
    name: "Rotten Tomatoes",
    key: "rottentomatoes",
  },
  IMDB: {
    name: "IMDb",
    key: "imdb",
  },
  TIKTOK: {
    name: "TikTok",
    key: "tiktok",
  },
  DISCORD: {
    name: "Discord",
    key: "discord",
  },
  GOOGLE: {
    name: "Google",
    key: "google",
  },
  PANTHEON_GLOBAL: {
    name: "Global",
    key: "pantheon_global",
  },
  GLOBAL_WIKIPEDIA: {
    name: "Wikipedia (Global)",
    key: "global_wikipedia",
  },
  GLOBAL_STEAM: {
    name: "Steam (Global)",
    key: "global_steam",
  },
  GLOBAL_TWITCH: {
    name: "Twitch (Global)",
    key: "global_twitch",
  },
  GLOBAL_IMDB: {
    name: "IMDb (Global)",
    key: "global_imdb",
  },
  GLOBAL_ROTTEN_TOMATOES: {
    name: "Rotten Tomatoes (Global)",
    key: "global_rottentomatoes",
  },
  GLOBAL_YOUTUBE: {
    name: "YouTube (Global)",
    key: "global_youtube",
  },
  GOOGLE_SEARCH: {
    name: "Google Search",
    key: "google",
  },
  BOX_OFFICE: {
    name: "Box Office",
    key: "boxoffice",
  },
  FRANCHISE_SCORE: {
    name: "Franchise Score",
    key: "franchise_score",
  },
  PLATFORM_SCORES: {
    name: "Platform Scores",
    key: "platform_scores",
  },
  SENTIMENT: {
    name: "Sentiment",
    key: "sentiment",
  },
  AMAZON_BOOKS: {
    name: "Amazon Books",
    key: "amazonbooks",
  },
  BARNES_AND_NOBLE: {
    name: "Barnes & Noble",
    key: "barnesnoble",
  },
  GOODREADS: {
    name: "Goodreads",
    key: "goodreads",
  },
  STORYGRAPH: {
    name: "Storygraph",
    key: "storygraph",
  },
  FABLEBOOKS: {
    name: "Fablebooks",
    key: "fablebooks",
  }
};

export const DATAPOINTS = {
  WIKIPEDIA: {
    PAGE_VIEWS: {
      name: "Page Views",
      key: "page_views",
    },
    RANK: {
      name: "Rank",
      key: "rank",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "wikipedia",
    },
  },
  TWITTER: {
    TWEET_COUNT: {
      name: "Tweets",
      key: "tweets",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "twitter",
    },
  },
  REDDIT: {
    SUBREDDIT_MEMBERS_TOTAL: {
      name: "Members (total)",
      key: "subscribers_total",
    },
    UPVOTES: {
      name: "Upvotes",
      key: "upvotes",
    },
    COMMENTS: {
      name: "Comments",
      key: "comments",
    },
    SUBREDDIT_MEMBERS: {
      name: "Members",
      key: "subscribers",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "reddit",
    },
  },
  STEAM: {
    PLAYER_COUNT_AVG: {
      name: "Average Players",
      key: "player_count_avg",
    },
    RECOMMENDATIONS: {
      name: "Reviews (total)",
      key: "recommendations",
    },
    HUB_MEMBERS: {
      name: "Community Hub Members",
      key: "hub_members",
    },
    PLAYER_COUNT: {
      name: "Players",
      key: "player_count",
    },
    RANK: {
      name: "Rank",
      key: "rank",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "steam",
    },
  },
  TWITCH: {
    VIEWER_COUNT_PEAK: {
      name: "Peak Viewers",
      key: "viewers_peak",
    },
    NEW_FOLLOWERS: {
      name: "New Followers",
      key: "new_followers",
    },
    VIEWER_COUNT: {
      name: "Viewers",
      key: "viewers",
    },
    STREAMER_COUNT: {
      name: "Streamers",
      key: "broadcasters",
    },
    RANK: {
      name: "Rank",
      key: "rank",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "twitch",
    },
  },
  YOUTUBE: {
    VIEWS: {
      name: "Views",
      key: "views",
    },
    COMMENTS: {
      name: "Comments",
      key: "comments",
    },
    LIKES: {
      name: "Likes",
      key: "likes",
    },
    RANK: {
      name: "Rank",
      key: "rank",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "youtube",
    },
  },
  WATTPAD: {
    VIEWS_DIFF: {
      name: "Views",
      key: "views_diff",
    },
    COMMENTS_DIFF: {
      name: "Comments",
      key: "comments_diff",
    },
    STARS_DIFF: {
      name: "Stars",
      key: "stars_diff",
    },
    VIEWS: {
      name: "Views",
      key: "views",
    },
    COMMENTS: {
      name: "Comments",
      key: "comments",
    },
    STARS: {
      name: "Stars",
      key: "stars",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "wattpad",
    },
  },
  AO3: {
    HITS_DIFF: {
      name: "Hits",
      key: "hits_diff",
    },
    COMMENTS_DIFF: {
      name: "Comments",
      key: "comments_diff",
    },
    KUDOS_DIFF: {
      name: "Kudos",
      key: "kudos_diff",
    },
    BOOKMARKS_DIFF: {
      name: "Bookmarks",
      key: "bookmarks_diff",
    },
    WORKS_DIFF: {
      name: "Works Added",
      key: "works_diff",
    },
    HITS: {
      name: "Hits",
      key: "hits",
    },
    COMMENTS: {
      name: "Comments",
      key: "comments",
    },
    KUDOS: {
      name: "Kudos",
      key: "kudos",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "ao3",
    },
  },
  PIRACY: {
    DOWNLOADS: {
      name: "Downloads",
      key: "downloads",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "piracy",
    },
  },
  IMDB: {
    VOTES_TOTAL: {
      name: "Votes (total)",
      key: "votes_total",
    },
    VOTES: {
      name: "Votes",
      key: "votes",
    },
    RATING: {
      name: "Rating",
      key: "rating",
    },
    RANK: {
      name: "Rank",
      key: "rank",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "imdb",
    },
  },
  ROTTEN_TOMATOES: {
    AUDIENCE_VOTES: {
      name: "Audience Votes",
      key: "audience_votes",
    },
    AUDIENCE_RATING: {
      name: "Audience Rating",
      key: "audience_rating",
    },
    CRITIC_VOTES: {
      name: "Critic Votes",
      key: "critic_votes",
    },
    CRITIC_RATING: {
      name: "Critic Rating",
      key: "critic_rating",
    },
    RANK: {
      name: "Rank",
      key: "rank",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "rotten_tomatoes",
    },
  },
  FANDOM: {
    PAGES_DIFF: {
      name: "Pages Added",
      key: "pages_diff",
    },
    ARTICLES_DIFF: {
      name: "Articles Added",
      key: "articles_diff",
    },
    EDITS_DIFF: {
      name: "Edits",
      key: "edits_diff",
    },
    PAGES: {
      name: "Pages",
      key: "pages",
    },
    ARTICLES: {
      name: "Articles",
      key: "articles",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "fandom",
    },
  },
  TIKTOK: {
    VIEWS: {
      name: "Views",
      key: "views",
    },
    POSTS: {
      name: "Posts",
      key: "posts",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "tiktok",
    },
  },
  AMAZON_BOOKS: {
    RATINGS_DIFF: {
      name: "Ratings",
      key: "ratings_diff",
    },
    AVERAGE_RATING: {
      name: "Average Rating",
      key: "rating",
    },
    RATINGS: {
      name: "Ratings",
      key: "ratings",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "amazonbooks",
    },
  },
  BARNES_AND_NOBLE: {
    RATINGS_DIFF: {
      name: "Ratings",
      key: "ratings_diff",
    },
    AVERAGE_RATING: {
      name: "Average Rating",
      key: "rating",
    },
    RATINGS: {
      name: "Ratings",
      key: "ratings",
    },
    SALES_RANK: {
      name: "Sales Rank",
      key: "sales_rank",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "barnesnoble",
    },
  },
  GOODREADS: {
    RATINGS_DIFF: {
      name: "Ratings",
      key: "ratings_diff",
    },
    REVIEWS_DIFF: {
      name: "Reviews",
      key: "reviews_diff",
    },
    AVERAGE_RATING: {
      name: "Average Rating",
      key: "rating",
    },
    RATINGS: {
      name: "Ratings",
      key: "ratings",
    },
    REVIEWS: {
      name: "Reviews",
      key: "reviews",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "goodreads",
    },
  },
  STORYGRAPH: {
    REVIEWS_DIFF: {
      name: "Reviews",
      key: "reviews_diff",
    },
    AVERAGE_RATING: {
      name: "Average Rating",
      key: "rating",
    },
    RATINGS: {
      name: "Reviews",
      key: "reviews",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "storygraph",
    },
  },
  FABLEBOOKS: {
    REVIEWS_DIFF: {
      name: "Reviews",
      key: "reviews_diff",
    },
    AVERAGE_RATING: {
      name: "Average Rating",
      key: "rating",
    },
    RATINGS: {
      name: "Reviews",
      key: "reviews",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "fablebooks",
    },
  },
  DISCORD: {
    ZSCORE: {
      name: "Z-Score",
      key: "discord",
    },
  },
  FRANCHISE_SCORE: {
    SCORE: {
      name: "Franchise Score",
      key: "franchise_score",
    },
  },
  SENTIMENT: {
    SENTIMENT: {
      name: "Sentiment",
      key: "sentiment",
    },
  },
  MYANIMELIST: {
    RATINGS: {
      name: "Ratings",
      key: "ratings",
    },
    LIST_USERS: {
      name: "List Users",
      key: "list_users",
    },
    RATINGS_DIFF: {
      name: "Ratings",
      key: "ratings_diff",
    },
    LIST_USERS_DIFF: {
      name: "List Users",
      key: "list_users_diff",
    },
    RATING: {
      name: "Rating",
      key: "rating",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "myanimelist",
    },
  },
  ANILIST: {
    LIST_USERS: {
      name: "List Users (total)",
      key: "list_users",
    },
    FAVORITES: {
      name: "Favorites (total)",
      key: "favorites",
    },
    FAVORITES_DIFF: {
      name: "Favorites",
      key: "favorites_diff",
    },
    IN_PROGRESS_DIFF: {
      name: "In Progress",
      key: "in_progress_diff",
    },
    LIST_USERS_DIFF: {
      name: "List Users",
      key: "list_users_diff",
    },
    POPULARITY: {
      name: "Popularity",
      key: "popularity",
    },
    RATING: {
      name: "Rating",
      key: "rating",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "anilist",
    },
  },
  
  
  GOOGLE_SEARCH: {
    VOLUME_GENERAL_CATEGORY: {
      name: "Volume (Title & Category)",
      key: "general.category",
    },
    VOLUME_GENERAL_RELEASE_YEAR: {
      name: "Volume (Title & Release Year)",
      key: "general.release_year",
    },
    VOLUME_INTENT_TO_WATCH_WHERE_TO_WATCH: {
      name: "Volume (Intent to Watch - Where to Watch)",
      key: "intent_to_watch.where_to_watch",
    },
    VOLUME_INTENT_TO_WATCH_NETFLIX: {
      name: "Volume (Intent to Watch - Netflix)",
      key: "intent_to_watch.ott.netflix",
    },
    VOLUME_INTENT_TO_WATCH_DISNEY_PLUS: {
      name: "Volume (Intent to Watch - Disney+)",
      key: "intent_to_watch.ott.disneyplus",
    },
    VOLUME_INTENT_TO_WATCH_HBO_MAX: {
      name: "Volume (Intent to Watch - HBO Max)",
      key: "intent_to_watch.ott.hbomax",
    },
    VOLUME_INTENT_TO_WATCH_HULU: {
      name: "Volume (Intent to Watch - Hulu)",
      key: "intent_to_watch.ott.hulu",
    },
    VOLUME_INTENT_TO_WATCH_AMAZON_PRIME_VIDEO: {
      name: "Volume (Intent to Watch - Amazon Prime Video)",
      key: "intent_to_watch.ott.amazonprimevideo",
    },
    VOLUME_INTENT_TO_WATCH_APPLE_TV_PLUS: {
      name: "Volume (Intent to Watch - Apple TV+)",
      key: "intent_to_watch.ott.appletvplus",
    },
    VOLUME_INTENT_TO_WATCH_PEACOCK: {
      name: "Volume (Intent to Watch - Peacock)",
      key: "intent_to_watch.ott.peacock",
    },
    VOLUME_INTENT_TO_WATCH_PARAMOUNT_PLUS: {
      name: "Volume (Intent to Watch - Paramount+)",
      key: "intent_to_watch.ott.paramountplus",
    },
    VOLUME_INTENT_TO_WATCH_CABLE: {
      name: "Volume (Intent to Watch - Cable)",
      key: "intent_to_watch.cable",
    },
    VOLUME_INTENT_TO_WATCH_PHYSICAL: {
      name: "Volume (Intent to Watch - Physical)",
      key: "intent_to_watch.physical",
    },
    VOLUME_INTENT_TO_WATCH_THEATRICAL: {
      name: "Volume (Intent to Watch - Theatrical)",
      key: "intent_to_watch.theatrical",
    },
    VOLUME_INTENT_TO_WATCH_PIRACY: {
      name: "Volume (Intent to Watch - Piracy)",
      key: "intent_to_watch.piracy",
    },
    VOLUME_INTENT_TO_WATCH_LATEST_SEASON: {
      name: "Volume (Intent to Watch - Latest Season)",
      key: "intent_to_watch.latest_season",
    },
    VOLUME_INTENT_TO_PLAY_WHERE_TO_PLAY: {
      name: "Volume (Intent to Play - Where to Play)",
      key: "intent_to_play.where_to_play",
    },
    VOLUME_INTENT_TO_PLAY_STEAM: {
      name: "Volume (Intent to Play - Steam)",
      key: "intent_to_play.digital.steam",
    },
    VOLUME_INTENT_TO_PLAY_EPIC_GAMES: {
      name: "Volume (Intent to Play - Epic Games Store)",
      key: "intent_to_play.digital.epicgames",
    },
    VOLUME_INTENT_TO_PLAY_GOG: {
      name: "Volume (Intent to Play - GOG)",
      key: "intent_to_play.digital.gog",
    },
    VOLUME_INTENT_TO_PLAY_PLAYSTATION: {
      name: "Volume (Intent to Play - PlayStation)",
      key: "intent_to_play.digital.playstation",
    },
    VOLUME_INTENT_TO_PLAY_XBOX: {
      name: "Volume (Intent to Play - Xbox)",
      key: "intent_to_play.digital.xbox",
    },
    VOLUME_INTENT_TO_PLAY_CONSOLE: {
      name: "Volume (Intent to Play - Console)",
      key: "intent_to_play.physical.console",
    },
    VOLUME_INTENT_TO_PLAY_PC: {
      name: "Volume (Intent to Play - PC)",
      key: "intent_to_play.physical.pc",
    },
    VOLUME_LEARN_ABOUT_GENERAL: {
      name: "Volume (Learn About - General)",
      key: "learn_about.general",
    },
    VOLUME_LEARN_ABOUT_NEWS: {
      name: "Volume (Learn About - News)",
      key: "learn_about.news",
    },
    VOLUME_LEARN_ABOUT_SOCIAL: {
      name: "Volume (Learn About - Social)",
      key: "learn_about.social",
    },
    VOLUME_LEARN_ABOUT_AWARDS: {
      name: "Volume (Learn About - Awards)",
      key: "learn_about.awards",
    },
    VOLUME_LEARN_ABOUT_REVIEWS: {
      name: "Volume (Learn About - Reviews)",
      key: "reviews",
    },
    VOLUME_LEARN_ABOUT_TRAILERS: {
      name: "Volume (Learn About - Trailers)",
      key: "learn_about.trailers",
    },
    ZSCORE: {
      name: "Z-Score",
      key: "google",
    },
  },
  BOX_OFFICE: {
    GROSS_DOMESTIC: {
      name: "Domestic Gross",
      key: "gross",
    },
  },
};

export const YOUTUBE_CATEGORIES = [
  { label: "All", value: "All" },
  { label: "Gaming", value: "Gaming" },
  { label: "Entertainment", value: "Entertainment" },
  { label: "Sports", value: "Sports" },
  { label: "Music", value: "Music" },
  { label: "People & Blogs", value: "People & Blogs" },
  { label: "Film & Animation", value: "Film & Animation" },
  { label: "News & Politics", value: "News & Politics" },
  { label: "Comedy", value: "Comedy" },
  { label: "Education", value: "Education" },
  { label: "Autos & Vehicles", value: "Autos & Vehicles" },
  { label: "Howto & Style", value: "Howto & Style" },
  { label: "Science & Technology", value: "Science & Technology" },
  { label: "Travel & Events", value: "Travel & Events" },
  { label: "Pets & Animals", value: "Pets & Animals" },
  { label: "Nonprofits & Activism", value: "Nonprofits & Activism" },
];

export const GLOBAL_SHEET_VERTICAL_MAP = {
  [Vertical.Movies]: "movies",
  [Vertical.Series]: "series",
  [Vertical.Games]: "gaming",
  [Vertical.Franchises]: "franchise",
  [Vertical.Books]: "book",
  [Vertical.Anime]: "anime",
  [Vertical.Manga]: "manga",
};

export const RANKING_PAGE_MAP = {
  [Vertical.Movies]: "movies",
  [Vertical.Series]: "series",
  [Vertical.Games]: "games",
  [Vertical.Franchises]: "franchises",
  [Vertical.Books]: "books",
  [Vertical.Anime]: "anime",
  [Vertical.Manga]: "manga",
};